/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Irrigation_Run_Status_SkippedInputs */

const vi_irrigation_run_status_skipped = /** @type {(inputs: Irrigation_Run_Status_SkippedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bỏ qua`)
};

/**

* @param {Irrigation_Run_Status_SkippedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_run_status_skipped = /** @type {((inputs?: Irrigation_Run_Status_SkippedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Run_Status_SkippedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_run_status_skipped(inputs)
});